/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 19.07.24
 *
 */
import RecipientItem from "@shared/Profile/RecipientItem";

export default class SenderItem extends RecipientItem {


	constructor() {
		super();
	}
}
